











































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { companiesCollection, drillingCollection } from '@/firebaseConfig.ts';
import { auth } from '@/firebaseConfig.ts';
import { User } from '../../types';

@Component
export default class Login extends Vue {
  incident: Object | undefined = {};
  comments: Array<Object> = [];

  get hasPhoto() {
    return (
      this.incident &&
      this.incident.hasOwnProperty('photos') &&
      this.incident['photos'].length > 0
    );
  }

  getTagColor(tag: string): string {
    if (!tag) return 'grey';
    tag = tag.toLowerCase();
    if (tag.search('at risk') > -1) return 'orange';
    if (tag.search('near miss') > -1) return 'blue';
    if (tag.search('non recordable') > -1) return 'orange';
    if (tag.search('recordable') > -1) return 'yellow';
    if (tag.search('lost time') > -1) return 'blue';
    if (tag.search('fatal') > -1) return 'red';
    return 'grey';
  }

  async mounted() {
    const drillingId = this.$route.params.id;
    const docRef = await drillingCollection.doc(drillingId);
    docRef.onSnapshot(snapshot => {
      if (snapshot.exists) {
        const data = snapshot.data();
        console.log(data);
        this.incident = data;
        docRef
          .collection('comments')
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              console.log(doc);
              this.comments.push(doc.data());
            });
          });
      }
    });
  }
}
